import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { CreatePromotionReplyDto } from '@diritto/common/promotion/dtos/create-promotion-reply.dto';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { PromotionReplyApi } from 'api/ApiHelper';

export const useCreatePromotionReplyMutation = (
  promotionId: number,
  options?: UseMutationOptions<ResponseDto, unknown, CreatePromotionReplyDto>,
) =>
  useMutation({
    mutationFn: (replyDto: CreatePromotionReplyDto) => PromotionReplyApi.createPromotionReply(promotionId, replyDto),
    ...options,
  });
